import { call, put, takeLatest } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { PUT } from '../consts/Methods';
import { CHANGE_USER_PASSWORD, CHANGE_USER_PASSWORD_SUCCESS, CHANGE_USER_PASSWORD_FAIL } from '../redux/UserData';

function* changeUserPasswordFlow({ payload: { dealer, promise: { resolve, reject, }, }, }) {
  try {
    const endpoint = `${apiRoot}/profiles/update_password`;
    const response = yield call(apiCall, { method: PUT, endpoint, params: { dealer, }, });
    yield put(CHANGE_USER_PASSWORD_SUCCESS({ data: response, }));
    resolve();
  } catch (error) {
    yield put(CHANGE_USER_PASSWORD_FAIL({ error, }));
    reject(new SubmissionError(error));
  }
}

export default function* ChangeUserPassword() {
  yield takeLatest(CHANGE_USER_PASSWORD, changeUserPasswordFlow);
}
